import UserAffirmationProgramService from 'src/modules/userAffirmationProgram/userAffirmationProgramService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'USERAFFIRMATIONPROGRAM_VIEW';

const userAffirmationProgramViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: userAffirmationProgramViewActions.FIND_STARTED,
      });

      const record = await UserAffirmationProgramService.find(id);

      dispatch({
        type: userAffirmationProgramViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: userAffirmationProgramViewActions.FIND_ERROR,
      });

      getHistory().push('/user-affirmation-program');
    }
  },
};

export default userAffirmationProgramViewActions;
